import React, { useEffect, useState } from 'react';


const Popup = ({ message, type = 'info', onClose, duration = 3000 }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (message) {
      // Start progress bar animation
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, duration - elapsed);
        setProgress((remaining / duration) * 100);
      }, 50);

      // Auto-close after duration
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => {
        clearInterval(interval);
        clearTimeout(timer);
      };
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  // Map custom types to Bootstrap alert classes
  const typeStyles = {
    success: 'alert-success',
    danger: 'alert-danger',
    warning: 'alert-warning',
    info: 'alert-info'
  };

  return (
    <div
      className={`alert ${typeStyles[type] || typeStyles.info} d-flex align-items-center justify-content-between position-fixed top-0 end-0 m-3 shadow animate-slide-in`}
      style={{ maxWidth: '30rem', width: '100%', zIndex: 9999 }} // High z-index
      role="alert"
      aria-live="assertive"
    >
      <span className="fs-6">{message}</span>
      <button
        type="button"
        className="btn-close ms-2"
        onClick={onClose}
        aria-label="Close notification"
      ></button>
      <div className="progress position-absolute bottom-0 start-0 w-100" style={{ height: '4px' }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${progress}%` }}
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
};

export default Popup;